import src from "IMAGE";
export default { src, width: 99, height: 90, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
